const INIT = 'custInfo/INIT';
const SET_CUST_INFO = 'custInfo/SET_CUST_INFO';
const SET_CLEAR_PRNT_INFO = 'custInfo/SET_CLEAR_PRNT_INFO';
const SET_CLEAR_CUST_INFO = 'custInfo/SET_CLEAR_CUST_INFO';
const SET_TEMP_SAVE_STEP_CD_INFO = 'custInfo/SET_TEMP_SAVE_STEP_CD_INFO';
const SET_CUST_TEMP_SAVE_INFO = 'custInfo/SET_CUST_TEMP_SAVE__INFO';
const SET_CUST_MINR_INFO = 'custInfo/SET_CUST_MINR_INFO';
const SET_ISRD_SAME_INFO = 'custInfo/SET_ISRD_SAME_INFO';

const initialState = {
  custNo: '',
  custNm: '',
  corpNm: '',
  bdt: '',
  bizNum: '',
  sex: '',
  postNo: '',
  addr: '',
  dtlAddr: '',
  hphnNo: '',
  corpHphnNo: '',
  minrYn: '0',
  isrdSameYn: null,
  prntAtrtNm: '',
  prntAtrtBdt: '',
  prntCatCd: '',
  tempSaveStepCd: '',
  isAddSend: false,
  isUpload: false,
  isPdf: false,
  perCorp: 'PER',
  updMktAgrYn: '',
  reWriteYn: '',
  pdfDownYn: '',
  singleYn: false,
  pdfPreYn: false,
  pdfPreCustNo: '',
  copyYn: false,
  pdfClickYn: false,
  cntrCustNo: '',
  isIsrd: false,
  mktTelYn: false,
  mktSmsYn: false,
  mktEmailYn: false,
};

export default function custInfo(state = initialState, { type, payload }) {
  switch (type) {
    case INIT:
      return initialState;
    case SET_CUST_INFO:
      let { name, value } = payload;

      if(name === 'minrYn') value = value === '0' ? '1' : '0';
      if(name === 'isrdSameYn') value = value === '0' ? '1' : '0';
      
      return { ...state, [name]: value };
    case SET_CLEAR_PRNT_INFO:
      return { 
        ...state,
        prntAtrtNm: '',
        prntAtrtBdt: '',
        prntCatCd: '',
      };
    case SET_CLEAR_CUST_INFO:
      return { 
        ...state,
        custNm: '',
        bdt: '',
        sex: '',
        hphnNo: '',
      };
    case SET_TEMP_SAVE_STEP_CD_INFO:
      let { custNo, tempSaveStepCd } = payload;
      
      return { 
        ...state,
        custNo,
        tempSaveStepCd,
      };
    case SET_CUST_TEMP_SAVE_INFO:
      const { 
        CUST_NO,
        CUST_NM,
        BDT,
        SEX,
        HPHN_NO,
        MINR_YN,
        ISRD_SAME_YN,
        POST_NO,
        ADDR,
        DTL_ADDR,
        PRNT_ATRT_NM,
        PRNT_ATRT_BDT,
        PRNT_CAT_CD,
      } = payload;
    
      return { 
        ...state,
        custNo: CUST_NO,
        custNm: CUST_NM,
        bdt: BDT,
        sex: SEX,
        hphnNo: HPHN_NO,
        minrYn: MINR_YN,
        isrdSameYn: ISRD_SAME_YN,
        postNo: POST_NO,
        addr: ADDR,
        dtlAddr: DTL_ADDR,
        prntAtrtNm: PRNT_ATRT_NM,
        prntAtrtBdt: PRNT_ATRT_BDT,
        prntCatCd: PRNT_CAT_CD,
      };
    case SET_CUST_MINR_INFO:
      let { isTrue } = payload;

      return { ...state, minrYn: isTrue };
    case SET_ISRD_SAME_INFO:
      let { isTrueIsrd } = payload;

    return { ...state, isrdSameYn: isTrueIsrd };
    case 'persist/PURGE':
      return initialState;
    
    default:
      return state;
  }
}

export function init() {
  return {
    type: INIT,
  };
}

export function setCustInfo(name, value) {
  return {
    type: SET_CUST_INFO,
    payload: { name, value },
  };
}

export function setClearPrntInfo() {
  return {
    type: SET_CLEAR_PRNT_INFO,
    payload: {},
  };
}

export function setClearCustInfo() {
  return {
    type: SET_CLEAR_CUST_INFO,
    payload: {},
  };
}

export function setTempSaveStepCdInfo(data) {
  return {
    type: SET_TEMP_SAVE_STEP_CD_INFO,
    payload: { 
      custNo: data.CUST_NO,
      tempSaveStepCd: data.TEMP_SAVE_STEP_CD,
     },
  };
}

export function setCustTempSaveInfo(data, isrdUseYn) {
  return {
    type: SET_CUST_TEMP_SAVE_INFO,
    payload: {
      ...data,
      // 피보험자 사용 업체의 기존 값이 없으면 동일로 처리
      ISRD_SAME_YN: isrdUseYn == '1' ? (data.ISRD_SAME_YN ?? '1') : null,
    },
  };
}

export function setCustMinrInfo(isTrue) {
  return {
    type: SET_CUST_MINR_INFO,
    payload: { isTrue },
  };
}

export function setIsrdSameInfo(isTrueIsrd) {
  return {
    type: SET_ISRD_SAME_INFO,
    payload: { isTrueIsrd },
  };
}